import SearchBox from './SearchBox.vue';
import SearchResult from './SearchResult.vue';
import SelectBox from './SelectBox.vue';
import MultiSelectBox from './MultiSelectBox.vue';
import ModalBase from './ModalBase.vue';
import ModalBase3 from './ModalBase3.vue';
import DialogBase from './DialogBase.vue';
import ModalInputBase from './ModalInputBase.vue';
import DashboardModalBase from './DashboardModalBase.vue';
// import GadgetIndex from './GadgetIndex.vue';
import ModalBaseBack from './ModalBaseBack.vue';

import SideModalBase from './SideModalBase.vue';
import SideModalGadgetList from './SideModalGadgetList.vue';
import SideBarBase from './SideBarBase.vue';
import SideMenuBase from './SideMenuBase.vue';
import VariableInput from '@/components/util/VariableInput.vue';
import ListDetail from './ListDetail.vue';
import CheckBoxList from './CheckBoxList.vue';

export default {
  SearchBox,
  SearchResult,
  SelectBox,
  MultiSelectBox,
  ModalBase,
  ModalBase3,
  ModalInputBase,
  DialogBase,
  DashboardModalBase,
  // GadgetIndex,
  ModalBaseBack,
  SideModalBase,
  SideModalGadgetList,
  SideBarBase,
  SideMenuBase,
  VariableInput,
  ListDetail,
  CheckBoxList,
};
